import { dayOfWeekForServiceDate } from 'utils/routeStopOperations/v2/dayOfWeek'
import { makePreflightStep } from 'utils/routeStopOperations/v2/steps/preflight'
import { makeSequenceDailySlotStep } from 'utils/routeStopOperations/v2/steps/sequenceDailySlot'
import { makeSequenceMasterSlotStep } from 'utils/routeStopOperations/v2/steps/sequenceMasterSlot'
import { makeVerifyStep } from 'utils/routeStopOperations/v2/steps/verify'

import type { Deps, OperationPlan, PipelineStep, ResequenceIntent } from 'types/modules/routing'

const STRATEGY_ID = 'v3-slot' as const

export const buildResequenceSlotPipeline = (intent: ResequenceIntent, deps: Deps): OperationPlan => {
  const steps: PipelineStep[] = [makePreflightStep({ intent }, deps) as PipelineStep]

  steps.push(
    makeSequenceDailySlotStep(
      { routeId: intent.routeId, serviceDate: intent.serviceDate, orderedRows: intent.orderedStops },
      deps
    ) as PipelineStep
  )

  const dayOfWeek = intent.includeMaster === true ? intent.masterDayOfWeek ?? dayOfWeekForServiceDate(intent.serviceDate) : null
  if (dayOfWeek) {
    steps.push(
      makeSequenceMasterSlotStep(
        { routeId: intent.routeId, dayOfWeek, orderedRows: intent.masterOrderedStops ?? intent.orderedStops },
        deps
      ) as PipelineStep
    )
  }

  steps.push(makeVerifyStep({ intent, expectedFinalCount: intent.orderedStops.length }, deps) as PipelineStep)

  return { strategy: STRATEGY_ID, intent, steps }
}
